import React from 'react';
import { Box, Typography } from '@mui/material';

const ComingSoon = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        textAlign: 'center',
        px: 2
      }}
    >
      <Typography variant="h4" component="h1" color="text.primary">
        Coming Soon
      </Typography>
    </Box>
  );
};

export default ComingSoon; 